const refreshSelectElements = (key, value) => {
  const select = document.querySelector(`select[name="${key}"]`);
  const option = document.createElement('option');

  select.innerHTML = '';
  option.value = value;
  option.text = value;
  option.setAttribute('selected', 'selected');
  select.add(option);
  select.value = value;
  select.dispatchEvent(new Event('change'));
}

const displayAdditionalInfo = (availabilityWrap, data) => {
  let deliveryInfo = '';

  if (data.is_in_stock === true) {
    deliveryInfo = `, ${data.adelivery_info}`;
    availabilityWrap.classList.remove('out-of-stock');
  }
  else {
    deliveryInfo = '';
    availabilityWrap.classList.add('out-of-stock');
  }

  availabilityWrap.innerText = `${data.availability_info}${deliveryInfo}`;
}

const updateQuantityValues = (data) => {
  const quantity = document.querySelector('input[name="quantity"]');
  const minQuantity = data.min_qty ? parseFloat(data.min_qty) : '';
  const maxQuantity = data.max_qty ? parseFloat(data.max_qty) : '';

  quantity.setAttribute('min', minQuantity);
  quantity.setAttribute('max', maxQuantity);
  quantity.value = minQuantity;
  quantity.dispatchEvent(new Event('change'));
}

const checkAvailability = (data) => {
  const addToCartBtn = document.querySelector('.woocommerce-variation-add-to-cart.variations_button');

  if (!(data.is_in_stock)) {
    addToCartBtn.style.display = 'none';
  } else {
    addToCartBtn.style.display = 'flex';
  }
}

const changeProductImage = (data) => {
  const mainImg = document.querySelector('.productCustomGallery__mainImage');
  const mainThumb = document.querySelector('.productCustomGallery__mainThumb img');
  productLightboxEl.destroy();
  if (mainImg) {
    const img = mainImg.querySelector('img');
    const lightbox = mainImg.querySelector('.lightBoxRun');

    img.src = data.image.src;
    img.srcset = data.image.srcset;
    lightbox.href = data.image.url;

    productLightboxEl = new window.lightbox({
      elements: '.lightBoxRun'
    });
  }

  if (mainThumb) {
    mainThumb.src = data.image.gallery_thumbnail_src;
    mainThumb.srcset = data.image.srcset;
  }
}

const changeVariantDetails = (data) => {
  const variationWrap = document.querySelector('.single_variation_wrap');
  const priceWrap = variationWrap.querySelector('.customProductPage__price');
  const availabilityWrap = variationWrap.querySelector('.customProductPage__availability');
  const varaintId = variationWrap.querySelector('input[name="variation_id"]');

  priceWrap.innerHTML = data.price_html;
  availabilityWrap.innerHTML = data.availability_html;
  varaintId.value = data.variation_id;
  displayAdditionalInfo(availabilityWrap, data);
  updateQuantityValues(data);
  checkAvailability(data);
  changeProductImage(data);
}

export const selectProductVariant = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const variantList = document.querySelector('.variantList');
    const selectedVariant = variantList.querySelector('.variantList__selected');
    const currentVariant = variantList.querySelector('.variantList__item--selected');
    const dropdown = variantList.querySelector('.variantList__dropdown');

    document.addEventListener('click', function (event) {
      let clickedElement = event.target;

      if (variantList && !variantList.contains(clickedElement)) {
        variantList.classList.remove('open');
      }
    });

    const completeData = (variant) => {
      const selectedVariantContent = selectedVariant.querySelector('.variantList__selectedContent');
      const data = JSON.parse(variant.getAttribute('data-variant'));
      const attributes = data.attributes;

      selectedVariantContent.innerHTML = variant.innerHTML;

      if (attributes) {
        Object.entries(attributes).forEach(([key, value]) => {
          refreshSelectElements(key, value);
        });
      }

      changeVariantDetails(data);
    }

    completeData(currentVariant);

    selectedVariant.addEventListener('click', () => {
      variantList.classList.toggle('open');
    });

    if (dropdown) {
      dropdown.addEventListener('click', (event) => {
        const item = event.target;

        if (item && item.matches && item.matches('.variantList__item')) {
          completeData(item);
          variantList.querySelector('.variantList__item--selected').classList.remove('variantList__item--selected');
          item.classList.add('variantList__item--selected');
          variantList.classList.remove('open');
        }
      });
    }
  });
}